import { useTabQuery } from '@features/api/productsSlice';
import { TabType } from '@features/api/response/tabContent/TabType';
import { TabContentTypes } from '@features/api/response/TabDetails';
import { InvestorQualificationStage } from '@features/api/response/User';
import { useUserQuery } from '@features/api/userSlice';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export const useTabData = <T extends TabContentTypes>(type: TabType) => {
  const { tabId: routeTabId } = useParams();
  const { data: user } = useUserQuery();
  const isProfileNotComplete =
    user?.investorQualificationStage ===
    InvestorQualificationStage.AwaitingQuestionnaire;
  const [tabId] = useState(routeTabId);

  const queryResult = useTabQuery(
    {
      tabId: tabId ?? '',
    },
    {
      skip:
        type !== TabType.OVERVIEW && (isProfileNotComplete || !tabId || !user),
    }
  );

  const data = queryResult.data && (queryResult.data.contents as T);
  return { ...queryResult, data };
};
